import { FILES } from '@/constants/analytics';
import { IMAGE_ACL_TYPES } from '@/constants';
import get from 'lodash/get';
import axios from 'axios';
import { getUrl, hosts } from '@/config/api.routes';

const MANAGEMENT_FILES_UPLOAD_URL = `${hosts.management}files/upload`;

export default {
  namespaced: true,

  state: {
    attachedFiles: [],
  },

  getters: {
    attachedFiles: state => state.attachedFiles,
  },

  mutations: {
    ATTACH_FILE(state, file) {
      if (!state.attachedFiles.find(item => item.url === file.url)) {
        state.attachedFiles = [...state.attachedFiles, file];
      }
    },
    CLEAR_ATTACHED_FILES(state) {
      state.attachedFiles = [];
    },
    REMOVE_ATTACHED_FILE(state, file) {
      state.attachedFiles.splice(state.attachedFiles.indexOf(file), 1);
    },
  },

  actions: {
    attachFile({ commit, rootState, dispatch }, { file, source = 'chat' }) {
      commit('ATTACH_FILE', file);

      dispatch(
        'notifications/emitEventToSocket',
        { name: FILES.ATTACHED,
          payload: {
            url: file.url,
            agent: get(rootState, 'agent.profile'),
            source,
          },
        },
        { root: true },
      );
      dispatch('assets/clearAttachedAssets', null, { root: true });
    },
    clearAttachedFiles({ commit }) {
      commit('CLEAR_ATTACHED_FILES');
    },
    removeAttachedFile({ commit }, file) {
      commit('REMOVE_ATTACHED_FILE', file);
    },
    upload(_, payload) {
      const { formData, url, onUploadProgress } = payload;

      return axios.post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress,
      });
    },

    /**
     * POST `file` to management `files/upload` with public ACL (webchat / dashboard image assets).
     * Reuses {@link upload}; callers receive the parsed JSON body (e.g. `{ url }`).
     */
    async uploadPublicManagementFile({ dispatch }, { file, url = MANAGEMENT_FILES_UPLOAD_URL, onUploadProgress }) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('acl', IMAGE_ACL_TYPES.PUBLIC);
      const response = await dispatch('upload', { formData, url, onUploadProgress });
      return get(response, 'data');
    },
    deleteFile(_, id) {
      return axios.delete(`${getUrl('files.base')}/${id}`);
    },
  },
};
